module.exports = __webpack_public_path__ + "static/img/SFG108-90W_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/SFG108-90W_1.png
// module id = jNXf
// module chunks = 0